import { render } from "./CollegeTable.vue?vue&type=template&id=3901964c"
import script from "./CollegeTable.vue?vue&type=script&lang=js"
export * from "./CollegeTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__